import { useRouter } from "next/router";
import SiteChrome from "@chrome/SiteChrome";
import { SiteHtmlPageTitle } from "@content/en/HtmlTitle";
import { AcceleratorsMetaDescription } from "@content/en/accelerators/MetaDescription";
import { AcceleratorsHtmlPageTitle } from "@content/en/accelerators/HtmlTitle";
import AcceleratorsPage from "@components/accelerators/AcceleratorsPage";
import { MetaDescription } from "@components/MetaDescription";
import { HtmlPageTitle } from "@components/HtmlPageTitle";

const AcceleratorsLandingPage = () => {
  const router = useRouter();
  const { category, feature } = router.query;

  return (
    <SiteChrome>
      <HtmlPageTitle
        title={`${AcceleratorsHtmlPageTitle} - ${SiteHtmlPageTitle}`}
      />
      <MetaDescription description={AcceleratorsMetaDescription} />

      <AcceleratorsPage
        category={category?.toString() || ""}
        feature={feature?.toString() || ""}
      />
    </SiteChrome>
  );
};

export default AcceleratorsLandingPage;
